import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "./context/themecontext";


function Settings() {
  const { theme, toggleTheme } = useTheme();
  const isDarkMode = theme === "dark";

  return (
    <div className={`transition-colors duration-300 ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-2xl mx-auto p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"} rounded-lg shadow-lg m-4`}>
        
        {/* Header */}
        <div className={`mb-8 pb-6 border-b ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}>
          <h1 className={`text-lg font-bold ${isDarkMode ? "text-white" : "text-gray-900"}`}>
            Settings
          </h1>
          <p className={`text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
            Manage your application preferences
          </p>
        </div>

        {/* Theme Toggle Section */}
        <div className={`p-2 rounded-lg border ${isDarkMode ? "border-gray-700 bg-gray-700/50" : "border-gray-200 bg-gray-50"}`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {isDarkMode ? (
                <Moon className="w-8 h-8 text-yellow-400" />
              ) : (
                <Sun className="w-8 h-8 text-amber-500" />
              )}
              <div>
                <h2 className={`text-lg font-semibold ${isDarkMode ? "text-white" : "text-gray-900"}`}>
                  Dark Mode
                </h2>
                <p className={`text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
                  {isDarkMode ? "Dark mode is currently enabled" : "Light mode is currently enabled"}
                </p>
              </div>
            </div>

            {/* Toggle Switch */}
            <button
              onClick={toggleTheme}
              className={`relative inline-flex h-12 w-20 items-center rounded-full transition-colors duration-300 ${
                isDarkMode ? "bg-blue-600" : "bg-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isDarkMode ? "focus:ring-offset-gray-800" : "focus:ring-offset-white"}`}
            >
              {/* Slider */}
              <span
                className={`inline-block h-10 w-10 transform rounded-full bg-white transition-transform duration-300 flex items-center justify-center ${
                  isDarkMode ? "translate-x-10" : "translate-x-1"
                }`}
              >
                {isDarkMode ? (
                  <Moon className="w-5 h-5 text-gray-900" />
                ) : (
                  <Sun className="w-5 h-5 text-amber-500" />
                )}
              </span>
            </button>
          </div>
        </div>

        {/* Info Box */}
        <div className={`mt-6 p-2 rounded-lg ${isDarkMode ? "bg-blue-900/30 border border-blue-700" : "bg-blue-50 border border-blue-200"}`}>
          <p className={`text-sm ${isDarkMode ? "text-blue-300" : "text-blue-800"}`}>
            💡 Your theme preference is saved and will be remembered when you return to the application.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Settings;

